import { Component, OnInit, ViewChild ,ViewChildren,QueryList} from '@angular/core';
import { MasterService } from 'src/app/masters/master.service';
import { OrganismModel } from '../../organisms/organism.model';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TelemedicineService } from '../telemedicine.service';
import * as CommonConstants from '../../../utils/common.constants';
import { AddDepartmentComponent } from 'src/app/masters/add-department/add-department.component';
import { AddAddressComponent } from 'src/app/masters/add-address/add-address.component';
import { AddContactComponent } from 'src/app/masters/add-contact/add-contact.component';
import { LoaderService } from 'src/app/common/loader.service';
import swal from 'sweetalert2';
import { IntlTelNumberComponent } from 'src/app/common/intl-tel-number/intl-tel-number.component';
import {CountryISO } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-add-telemedicine',
  templateUrl: './add-telemedicine.component.html',
  styleUrls: ['./add-telemedicine.component.scss']
})
export class AddTelemedicineComponent implements OnInit {

  organisms: OrganismModel[];
  categories: any[];
  types:any[];
  legalForms:any[];
  teleMedicineForm: FormGroup;
  submitted = false;
  partnerId: number;
  addTelemedicineTitle =true;
  editTelemedicineTitle;
  partnerType: number = CommonConstants.PARTNER_TELEMEDICINE_TYPE;
  categoriesType: any[];
  agmntQuality: any[];
  certification: any[];
  partnerGroup: any[];
  
  countries:any;
  CountryISO = CountryISO;
  @ViewChild(AddDepartmentComponent, { static: true }) hospDepartment: AddDepartmentComponent;
  @ViewChild(AddAddressComponent, { static: true }) hospAddress: AddAddressComponent;
  @ViewChild(AddContactComponent, { static: true }) hospContact: AddContactComponent;
  @ViewChildren(IntlTelNumberComponent) phoneNos: QueryList<IntlTelNumberComponent>
  constructor(private masterService: MasterService, private formBuilder: FormBuilder, private toasterService : ToastrService
    , private telemedicineService: TelemedicineService, private loaderService: LoaderService) { }

  ngOnInit() {
    this.loadMasterData();
    this.getFromGroup();
  }

  loadMasterData(){
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getCategory().subscribe(response => {
      if (response && response['result']) {
        this.categories =response['result'].filter(category => category.partnerType == this.partnerType);
      }
    })
    this.masterService.getCategoryType().subscribe(response => {
      if (response && response['result']) {
        this.types  =response['result'].filter(type => type.partnerType == this.partnerType);
      }
    })
    this.masterService.getLegalForm().subscribe(response => {
      if (response && response['result']) {
        this.legalForms = response['result'];
      }
    })
    this.masterService.getCategoryType().subscribe(response => {
      if (response && response['result']) {
        this.categoriesType  = response['result'];
      }
    })
    this.masterService.getCertification().subscribe(response => {
      if (response && response['result']) {
        this.certification = response['result'];
      }
    })
    this.masterService.getAgmntQualtiy().subscribe(response => {
      if (response && response['result']) {
        this.agmntQuality = response['result'];
      }
    })
    this.masterService.getGroup().subscribe(response => {
      if (response && response['result']) {
        this.partnerGroup = response['result'];
      }
    })
    this.masterService.getCountry().subscribe(response => {
      if (response && response['result']) {
        this.countries = response['result'];

      }
    })

  }

  
  get f() { return this.teleMedicineForm.controls; }

  /**
    * Declare form group
    *  
    */
  private getFromGroup() {
    this.teleMedicineForm = this.formBuilder.group({
      'telemId':[],
      'compaNuNumberEmployees':  new FormControl(),
      'compaVaEmail1': ['', Validators.email],
      'compaVaMobilePhone1': new FormControl(),
      'compaVaWorkPhone': new FormControl(),
      'compaVaMobilePhone2': new FormControl(),
      'compaVaNameEn': ['', Validators.required],
      'compaVaWorkFax': new FormControl(),
      'leforId': new FormControl(),
      'orgsmId': ['', Validators.required],
      'pacatId': new FormControl(),
      'pctypId': new FormControl(),
      'pagrpId': new FormControl(),
      'compaVaHomepage': new FormControl(),
      'agmntId': new FormControl(),
      'certiId': new FormControl(),
      'staRecCode': [true]

    })
  }

  save() {
    this.submitted = true;
    if (this.teleMedicineForm.invalid) {
      return;
    }
    this.teleMedicineForm.patchValue({ staRecCode: this.f.staRecCode.value ? 'A' : 'I'});
    let saveData = this.teleMedicineForm.value;
    this.phoneNos.forEach(phone => {
      saveData[phone.type]=phone.setPhoneNumberfrmInternation();
    })
    this.loaderService.display(true);
    this.telemedicineService.save(saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"]==0) {
        this.teleMedicineForm.patchValue({telemId: response['result']['telemId']});
        //this.toasterService.success(response['message'], 'Success');
        swal.fire("Success", response['message'], 'success');
      }else{
        //this.toasterService.error(response['message'], 'Error');
        swal.fire("Error", response['message'], 'error');
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  
reset(){
  this.teleMedicineForm.reset();
}
onChangeOrganism(event){
  if(event && event.cotryId){
    let country  =this.countries.filter(type => type.cotryId == event.cotryId);
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=country[0].cotryCode;
   })
  }else{
    this.phoneNos.forEach(phone => {
      phone.selectedCountry=CountryISO.France;
   })
  }
}

}
